module.exports = function _complement(f) {
  return function() {
    return !f.apply(this, arguments);
  };
};



//////////////////
// WEBPACK FOOTER
// /Users/cully/projects/Jobs/abound/~/ramda/src/internal/_complement.js
// module id = ../../node_modules/ramda/src/internal/_complement.js
// module chunks = 18